import { TStepsScheme } from '@cian/frontend-request-form-widget';

import { IFieldTransformSchema } from '../../repositories/legal-check/entities/field_transform/FieldTransformSchema';
import { EName as ERequestFormField } from '../../repositories/legal-check/entities/question_field/QuestionFieldSchema';
import { EStepCode } from '../../repositories/legal-check/entities/request/V1ProcessFormAnswersRequestSchema';
import { IRequestFormValue } from '../requestFormValue';
import { TRequestFormStep } from '../requestForm/requestFormStep';

export { EStepCode } from '../../repositories/legal-check/entities/request/V1ProcessFormAnswersRequestSchema';
export { EType as EInputType } from '../../repositories/legal-check/entities/question_field/QuestionFieldSchema';
export { EName as ERequestFormField } from '../../repositories/legal-check/entities/question_field/QuestionFieldSchema';

export enum ENotConfidentialRequestFormField {
  ObjectType = ERequestFormField.ObjectType,
  AddressCadastre = ERequestFormField.AddressCadastre,
}

export interface IRequestFormSchema {
  /** Значение формы для инициализации **/
  initialFormValue: IRequestFormValue;
  /** Первый шаг в схеме формы **/
  firstStepCode: EStepCode | string;
  /** Шаг с которого форма попытается инициализироваться **/
  initialStepCode: EStepCode | string;
  /** Словарь шагов, где ключ — идентификатор шага **/
  stepsSchema: TStepsScheme<TRequestFormStep>;
  /** Поля, которые необходимо трансформировать перед отправкой формы **/
  transformFields: IFieldTransformSchema[];
  /** Шаги, которые нужно пропустить **/
  skipSteps: EStepCode[] | string[];
}
